import React from 'react';
import './myeducation.css';
function SubjectResult ({subjectname, grade}){
    return (
        <li><p><span className="list-dot">•</span><span className="subject">{subjectname}:</span><span className="grade"><b>{grade}</b></span></p></li>
    )
}

export default SubjectResult